/**
 * mm:ss pace <-> seconds conversion, shared by Threshold Run Pace (sec/km)
 * and Critical Swim Pace (sec/100m) display + edit-form parsing on
 * AthleteProfileView.vue. Both are stored as plain seconds in
 * defaultAnalysisParams; only the UI deals in "mm:ss" strings.
 */

/** "4:15" -> 255. Returns null for anything that isn't valid mm:ss (empty, malformed, negative). */
export function parsePaceToSeconds(text: string): number | null {
  const trimmed = text.trim()
  if (!trimmed) return null

  const match = /^(\d+):([0-5]?\d)$/.exec(trimmed)
  if (!match) return null

  const minutes = Number(match[1])
  const seconds = Number(match[2])
  const total = minutes * 60 + seconds
  return total > 0 ? total : null
}

/** 255 -> "4:15". Returns '' for null/undefined/non-finite input. */
export function formatPaceFromSeconds(totalSeconds: number | null | undefined): string {
  if (totalSeconds == null || !Number.isFinite(totalSeconds) || totalSeconds <= 0) return ''
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = Math.round(totalSeconds % 60)
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}
